<template>
  <section class="phase">
    <template v-if="!game.gameEnded">
      <div class="phase__question">
        <span class="grid-hide"></span>
        <h2>{{ data.content.question }}</h2>
      </div>

      <transition @enter="enter" @leave="leave" mode="out-in">
        <div
          v-if="!game.answerChecked"
          class="phase__answer"
          :data-type="data.structure.type"
        >
          <component
            :is="componentsMap[data.structure.type]"
            :structure="data.structure"
          />
        </div>

        <div class="phase__content" data-type="paragraph" v-else :key="game.answerChecked">
          <span class="grid-hide"></span>
          <p v-html="data.content.content" />
        </div>
      </transition>
    </template>

    <template v-else>
      <div class="result__title">
        <span class="grid-hide"></span>
        <h2 v-html="$translate('layout').result.title"/>
      </div>

      <div class="result__content" data-type="paragraph">
        <span class="grid-hide"></span>
        <p v-html="$translate('layout').result.content" />
      </div>

      <a
        class="result__button result__button--blue"
        :href="shareLink"
        target="_blank"
        v-if="!inApp"
      >
        <AppButton
          action="share"
          :content="$translate('layout').shareButton"
          theme="blue"
        />
      </a>
      <div
        v-else
        class="result__button result__button--blue"
        @click="share"
      >
        <AppButton
          action="share"
          content="SHARE STORIES"
          theme="blue"
        />
      </div>

      <AppButton
        class="result__button result__button--orange"
        action="startGame"
        actionVariant="again"
        :content="$translate('layout').playAgainButton"
      />
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GameButtonsGroup from '@/components/GameButtonsGroup.vue';
import GameRange from '@/components/GameRange.vue';
import GameList from '@/components/GameList.vue';
import AppButton from '@/components/AppButton.vue';

import { initials, animations } from '@/scripts/animations';
import { inApp } from '@/scripts/utils';

export default {
  name: 'GameSection',

  components: {
    GameButtonsGroup,
    GameRange,
    GameList,
    AppButton,
  },

  data() {
    return {
      componentsMap: {
        button: 'GameButtonsGroup',
        boolean: 'GameButtonsGroup',
        range: 'GameRange',
        list: 'GameList',
      },
      inApp: inApp(),
    };
  },

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
    ...mapGetters({
      data: 'getCurrentQuestion',
    }),
    shareLink() {
      const src = `/share/offthegrid_gucci_${this.$store.state.currentGame.partialScore}_4.${this.$store.state.currentGame.partialScore === 4 ? 'mp4' : 'jpg'}`;
      // img.addEventListener('load', () => {
      //   const c = document.createElement('canvas');
      //   c.height = img.naturalHeight;
      //   c.width = img.naturalWidth;
      //   const ctx = c.getContext('2d');

      //   ctx.drawImage(img, 0, 0, c.width, c.height);
      //   const base64String = c.toDataURL();
      // });
      // const encode = encodeURIComponent(src);
      // window.open(`app://image?url=${encode}`, '_blank');

      return src;
    },
  },

  methods: {
    share() {
      // const img = new Image();

      // img.src = `/share/offthegrid_gucci_${this.$store.state.currentGame.partialScore}_4.jpg`;
      // img.addEventListener('load', () => {
      //   const c = document.createElement('canvas');
      //   c.height = img.naturalHeight;
      //   c.width = img.naturalWidth;
      //   const ctx = c.getContext('2d');

      //   ctx.drawImage(img, 0, 0, c.width, c.height);
      //   const base64String = c.toDataURL();
      //   const encode = encodeURIComponent(base64String);
      //   window.location.href = `app://share?url=${encode}`;
      // });

      const url = `https://offthegrid.firebaseapp.com/share/offthegrid_gucci_${this.$store.state.currentGame.partialScore}_4.${this.$store.state.currentGame.partialScore === 4 ? 'mp4' : 'jpg'}`;
      const encoded = encodeURI(url);
      window.location.href = `app://${this.$store.state.currentGame.partialScore === 4 ? 'video' : 'image'}?url=${encoded}`;
    },
    enter(el, done) {
      this.game.showNext = true;

      const anim = el.dataset.type;
      initials.get('grid-hide')(el.querySelector('.grid-hide'));
      initials.get(anim)(el.querySelector('p'));
      animations.get('grid-hide')(el.querySelector('.grid-hide'), 100);
      animations.get(anim)(el.querySelector('p'), 300).finished.then(done);
    },
    leave(el, done) {
      const anim = el.dataset.type;
      if (window.innerWidth >= 768) {
        const feedback = document.querySelector('.game-feedback');
        initials.get('feedback')(feedback);
        animations.get('feedback')(feedback, this.$store.state.currentGame.answerCorrect);
      }

      animations.get(`${anim}-out`)(el).finished.then(() => {
        // TODO: decide mq mobile
        if (window.innerWidth < 768) {
          const handlerHide = () => {
            this.$eventHub.$off('illustrationHidden', handlerHide);
            done();
          };
          this.$eventHub.$emit('showIllustration');
          this.$eventHub.$on('illustrationHidden', handlerHide);
        } else done();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.phase {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100vh;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(9, 1fr);

  &__question,
  .result__title {
    grid-column: 1 / -1;
    grid-row: 2 / 4;

    h2 {
      position: relative;

      @extend %font-size-question;
      font-weight: 700;
      max-width: 100%;

      padding: 0 calc(var(--unit-vw) * 0.25);
    }
  }

  &__question,
  &__content,
  .result__title,
  .result__content {
    position: relative;
    width: calc(100% - 2px);
    height: calc(100% - 2px);

    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: $color-bg;

    align-self: center;
    justify-self: center;

    @extend %font-size-s;
  }

  &__answer {
    grid-column: 1 / -1;

    &[data-type="list"],
    &[data-type="boolean"],
    &[data-type="button"],
     &[data-type="range"] {
      grid-row: 4 / 8;
    }

    &[data-type="range"] {
      grid-row: 5 / 7;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__content {
    grid-column: 1 / -1;
    grid-row: 4 / 8;

    padding: 0 calc(var(--unit-vw) * 0.25);

    p {
      display: block;
      width: 100%;
      font-weight: 300;
      line-height: inherit;
    }
  }

  .result__content {
    grid-column: 1 / -1;
    grid-row: 4 / 8;

    padding: 0 calc(var(--unit-vw) * 0.25);
    font-weight: 300;
  }

  .result__button {
    width: calc(100% - 2px);
    grid-row: 9 / -1;
    align-self: center;
    justify-self: center;

    .button {
      width: 100%;
      color: $color-blue;
    }

    &.result__button--blue {
      grid-column: 1 / 3;
      color: $color-blue;
    }

    &.result__button--orange {
      grid-column: 4 / -1;
      color: $color-red;
    }
  }

  @include mq($until: ipadP) {
    &__answer {
      padding: 20px;
      box-sizing: border-box;

      &[data-type="list"] {
        padding: 0;
      }

      &[data-type="button"] {
        padding: 30px;
      }
    }

    .result__button {
      &.result__button--blue {
        transform: translateX(20px) translateY(-10px);
      }
      &.result__button--orange {
        transform: translateX(-20px) translateY(-10px);
      }
    }
  }

  @include mq(ipadP) {
    grid-template-columns: repeat(10, 1fr);

    &__question,
    .result__title {
      grid-column: 2 / 10;
      grid-row: 2 / 4;

      h2 {
        padding: 0 calc(var(--unit-vw) * 0.5);
      }
    }

    &__answer {
      grid-column: 2 / 10;

      &[data-type="button"],
      &[data-type="list"] {
        grid-row: 4 / 7;
      }

      &[data-type="boolean"] {
        grid-row: 5 / 7;
      }

      &[data-type="range"] {
        grid-row: 5 / 7;
      }
    }

    &__content {
      grid-column: 2 / 10;
      grid-row: 4 / 7;

      padding: 0 calc(var(--unit-vw) * 0.7);
    }

    .result__content {
      grid-column: 2 / 10;
      grid-row: 4 / 7;

      padding: 0 calc(var(--unit-vw) * 0.5);
    }

    .result__button {
      width: calc(70% - 2px);
      grid-row: 8 / 9;
      align-self: center;
      justify-self: center;

      &.result__button--blue {
        grid-column: 3 / 6;
        color: $color-blue;
      }

      &.result__button--orange {
        grid-column: 6 / 9;
        color: $color-red;
      }
    }
  }
}
</style>
